<template>
  <div
    class="h-full master-container text-chplus-regular flex flex-col items-center"
  >
    <div class="hidden lg:flex w-full">
      <LargeDisplayNavbar v-if="!hideTopBar" />
    </div>
    <div
      :class="
        `master-container-content min-h-0 relative w-full flex flex-col flex-grow ${contentClass}`
      "
      :style="{
        paddingTop: paddingTop ? null : 0,
        paddingRight: paddingRight ? null : 0,
        paddingBottom: paddingBottom ? null : 0,
        paddingLeft: paddingLeft ? null : 0
      }"
    >
      <div class="flex flex-col flex-grow min-h-0">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script>
import LargeDisplayNavbar from "../nav/LargeDisplayNavbar.vue";

export default {
  name: "LayoutBase",
  props: {
    paddingTop: {
      type: Boolean,
      default: true
    },
    paddingRight: {
      type: Boolean,
      default: true
    },
    paddingBottom: {
      type: Boolean,
      default: true
    },
    paddingLeft: {
      type: Boolean,
      default: true
    },
    contentClass: {
      type: String,
      default: ""
    },
    hideTopBar: {
      type: Boolean,
      default: false
    }
  },
  components: {
    LargeDisplayNavbar
  }
};
</script>

<style scoped>
.master-container-content {
  padding: 1.624rem 0.84rem;
}

@media (min-width: 768px) {
  .master-container-content {
    padding: 1.856rem 2.16rem;
  }
}
</style>
